// Retries a fetch on transient failures only: the request never completed
// (fetch rejects with a TypeError — Safari's "Load failed", Chrome's "Failed
// to fetch", common on flaky mobile connections) or a gateway hiccup
// (502/503/504). Any other response, including 4xx and 500, is returned
// as-is for the caller to handle.
const RETRYABLE_STATUSES = [502, 503, 504];

export interface FetchRetryOptions {
  retries?: number;
  baseDelayMs?: number;
}

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export async function fetchWithRetry(
  input: RequestInfo | URL,
  init?: RequestInit,
  { retries = 2, baseDelayMs = 500 }: FetchRetryOptions = {},
): Promise<Response> {
  for (let attempt = 0; ; attempt += 1) {
    const isLastAttempt = attempt >= retries;
    try {
      const response = await fetch(input, init);
      if (isLastAttempt || !RETRYABLE_STATUSES.includes(response.status)) return response;
    } catch (error) {
      const isNetworkError = error instanceof TypeError;
      if (isLastAttempt || !isNetworkError || init?.signal?.aborted) throw error;
    }
    await wait(baseDelayMs * 3 ** attempt);
  }
}
